import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Intro from '@app/layout/Intro.tsx';
import React from 'react';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import Volumetric from '@app/pages/settings/Volumetric.tsx';

const VolumetricPage = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout
      title={tr(`Volumetric.pageTitle`, `Volumetric`)}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_SHIPMENT_MANUALIMPORT]}
    >
      <Volumetric />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(VolumetricPage, {
  onRedirecting: () => <Intro />,
});
